import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Star, MapPin, MessageCircleHeart } from "lucide-react";

const CountUp = ({ to, decimals = 0, suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: "easeOut",
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref} className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
      {val.toFixed(decimals)}
      <span className="text-fall-amber">{suffix}</span>
    </span>
  );
};

const ITEMS = [
  { icon: MessageCircleHeart, to: 91, suffix: "", label: "Google reviews" },
  { icon: Star, to: 4.7, decimals: 1, suffix: "★", label: "average rating" },
  { icon: MapPin, to: 5, suffix: "", label: "cities served" },
];

export const Counters = () => (
  <section data-testid="counters-section" className="border-y border-white/10 bg-brand-navy py-14">
    <div className="mx-auto grid max-w-5xl gap-10 px-4 text-center sm:grid-cols-3 sm:px-6">
      {ITEMS.map((item) => (
        <div key={item.label} data-testid={`counter-${item.label.replace(/\s/g, "-")}`} className="flex flex-col items-center gap-2">
          <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-fall-amber/15 text-fall-amber">
            <item.icon className="h-5 w-5" />
          </span>
          <CountUp to={item.to} decimals={item.decimals || 0} suffix={item.suffix} />
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-300">{item.label}</p>
        </div>
      ))}
    </div>
  </section>
);
